import React, {Component} from "react";
import {toast} from 'react-toastify';
import { connect } from 'react-redux';
import {freezeActivePoll, unFreezeActivePoll, getActivePollStatus} from '../Services/PollService';
import '../PollFreezeCard.css';

class PollFreezeCard extends React.Component{
    constructor(props){
        super(props);

        this.state={
            isFrozen:false,
            loading: false,
            frozenAt:null,
            frozenBy:null
        };
    }

    componentDidMount(){
        this.loadPollStatus();
    }

loadPollStatus=()=>{
    getActivePollStatus()
        .then(response=>{
            console.log(response);
            this.setState({
                isFrozen:response.data.isScoreFrozen,
                frozenAt: response.data.frozenAt,
                frozenBy: response.data.frozenBy,
            });
        })
        .catch(()=>{
            toast("Unable to load score status.");
        });
    };

        handleFreeze=()=>{
            const {isFrozen, frozenBy, frozenAt}= this.state;
            this.setState({loading: true});

            const request= isFrozen
                ? unFreezeActivePoll()
                : freezeActivePoll();

            request.then((response)=>{
                this.setState({
                    isFrozen:!isFrozen,
                    frozenBy: isFrozen? null: response.data.frozenBy,
                    frozenAt: isFrozen? null: response.data.frozenAt,
                    loading:false
                });

                toast(
                    isFrozen    
                        ? "Scores unfozen"
                        : "Scores frozen"
                );
            }).catch(()=>{
                this.setState({
                    loading:false
                });

                toast("Unable to update score status.");
            });
        };

        render(){
            return (
            <div className="score-control-card">    
            <h3 className="section-header">Score Control</h3>                     
                        <form>
                            <div className="form-group">
                                <button
                                    className={this.state.isFrozen? "unfreeze-button" : "freeze-button"}
                                    disabled={this.state.loading}
                                    onClick={this.handleFreeze}
                                    >
                                        {
                                            this.state.loading  
                                                ? "Processing"
                                                :
                                                this.state.isFrozen
                                                ? "Unfreeze Scores"
                                                : "Freeze Scores"
                                        }
                                </button>
                            </div>
                        </form>
                {this.state.isFrozen &&(
                <div className="freeze-details">
                    <div className="freeze-detail">                    
                        <span className="label">Frozen By:</span>
                        <span className="value">{this.state.frozenBy}</span>            
                    </div>
                    <div className="freeze-detail">                    
                        <span className="label">Frozen At:</span>
                        <span className="value">{new Date( this.state.frozenAt).toLocaleString("en-US",{
                            timeZone:"America/New_York",
                            day:"2-digit",
                            month:"short",
                            year:"numeric",
                            hour:"2-digit",
                            minute:"2-digit",
                            hour12:true
                        })}</span>            
                    </div>
                </div>
                )}
            </div>
            );
        }    
}

export {PollFreezeCard};